import React from 'react'
import { useSelector } from "react-redux"
import { Link } from 'react-router-dom'
import { Container, Button } from "react-bootstrap"
import { RootState } from '../store/store'
import { useTranslation } from 'react-i18next';
import { Invoice } from '../types/invoiceForm'
import InvoiceList from '../components/InvoiceList'


const InvoicePage: React.FC = () => {
  const { t } = useTranslation();  
  const invoices = useSelector((state: RootState) => state.invoices as Invoice[])
  return (
    <div className="d-flex flex-column align-items-center w-100">
      <Container className="mt-5 mb-5">
        <div className='d-flex justify-content-between'>
          <div className='mb-3'>
            <h1>{t('invoices')}</h1>
            <span>{t('totalInvoices')}: {invoices?.length}</span>
          </div>
          <div className='mb-2'>
            <Link to="/create" state={{ type: 'invoice' }}>
              <Button variant="primary" size="sm">
                + {t('createInvoice')}
              </Button>
            </Link>{' '}
          </div>
        </div>
        <InvoiceList invoices={invoices} />
      </Container>
    </div>
  )
}

export default InvoicePage
